
import { defineComponent } from 'vue';
import LoadElements from '@/components/template-builder/LoadElements.vue';
import { LoadSectionPayload } from '@/types';
import { useI18n } from 'vue-i18n';
import { hideLeftToolbar } from '@/composables/template-editor/TemplateEditor';
import Panel from 'primevue/panel';

export default defineComponent({
  name: 'LoadElementsPanel',

  components: {
    LoadElements,
    Panel,
  },

  setup() {
    const { t } = useI18n();
    const payload: LoadSectionPayload = { position: 'top', selector: '#spm_body .spm_section:first-child' };

    return {
      t,
      payload,
      hideLeftToolbar,
    };
  },
});
